<template>
  <div>
    <el-card shadow="never">
      <h2 style="margin-top:unset;">Booking Courier - SCG</h2>
      <el-row :gutter="20">
        <el-col :span="8" :offset="4">
            <el-date-picker
            v-model="datePickTo"
            type="daterange"
            format="dd / MM / yyyy"
            value-format="yyyy-MM-dd"
            range-separator="To"
            style="width: 100%;"
            start-placeholder="วันที่เริ่มต้น"
            end-placeholder="วันที่สินสุด">
          </el-date-picker>
        </el-col>
        <el-col :span="4">
          <el-button
            icon="el-icon-search"
            style="width: 100%;"
            type="primary"
            @click="fetchNotifySCG"
          >ค้นหา</el-button>
        </el-col>
        <el-col :span="4">
          <el-button
            style="width: 100%;"
            type="primary"
            @click="exportExcel"
            :disabled="!onExport"
          >Export Excel</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="margin-top:15px;">
        <el-col :span="24">
          <data-tables
            :data="items"
            class="tableSCG"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column label="เวลา" width="160">
              <div class="text-md-left" slot-scope="scope">
                  <b>{{  $dayjs(scope.row.createdAt).format('DD/MM/YYYY HH:mm:ss') }}</b>
              </div>
            </el-table-column>
            <el-table-column prop="orderCode" label="orderCode" width="140"></el-table-column>
            <el-table-column prop="orderDate" label="orderDate" width="140">
              <div class="text-md-left" slot-scope="scope">
                  {{  $dayjs(scope.row.orderDate).format('DD/MM/YYYY') }}
              </div>
            </el-table-column>
            <el-table-column prop="orderTime" label="orderTime" width="140"></el-table-column>
            <el-table-column prop="shipperCode" label="shipperCode" width="140"></el-table-column>
            <el-table-column prop="shipperName" label="shipperName" width="200"></el-table-column>
            <el-table-column prop="shipperAddress" label="shipperAddress" width="250"></el-table-column>
            <el-table-column prop="shipperZipcode" label="shipperZipcode" width="130"></el-table-column>
            <el-table-column prop="shipperTel" label="shipperTel" width="140"></el-table-column>
            <el-table-column prop="deliveryDate" label="deliveryDate" width="140">
              <div class="text-md-left" slot-scope="scope">
                  {{  $dayjs(scope.row.deliveryDate).format('DD/MM/YYYY') }}
              </div>
            </el-table-column>
            <el-table-column prop="note" label="note"></el-table-column>
            <el-table-column prop="totalBox" label="totalBox" width="80"></el-table-column>
          </data-tables>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>
<script>
import fgApi from '@/services/fillgoods'
import mixinExcel from '@/mixins/exportExcel.js'
export default {
    name: 'NotifyCourierSCG',
    mixins: [mixinExcel],
    data () {
        return {
            datePick: this.$dayjs(new Date()).format('YYYY-MM-DD'),
            items: [],
            onExport: false,
            selectedRow: [],
            // datePickTo: [this.$dayjs(new Date()).format('YYYY-MM-DD'), this.$dayjs(new Date()).add(7, 'day').format('YYYY-MM-DD')]
            datePickTo: [this.$dayjs(new Date()).format('YYYY-MM-DD'), this.$dayjs(new Date()).format('YYYY-MM-DD')]
        }
    },
    created () {
        this.fetchNotifySCG()
    },
    watch: {
        selectedRow (val) {
            if (val.length > 0) {
                this.onExport = true
            } else {
                this.onExport = false
            }
        }
    },
    methods: {
        async fetchNotifySCG () {
            if (this.datePick) {
                this.$loading()

                let param = {
                    from: this.datePickTo[0],
                    to: this.datePickTo[1]
                }
                try {
                    let res = await fgApi.courier.getAllScgnotify(param)
                    if (res.success) {
                        this.items = res.data
                        console.log(this.items)
                    }
                } catch (error) {
                    console.log(error)
                    this.$message.error(error.message)
                }
                this.$loading().close()
            } else {
                this.$message({
                    type: 'warning',
                    message: 'กรุณาเลือกวันที่'
                })
            }
            // this.$loading().close()
        },
        exportExcel () {
            if (this.selectedRow.length > 0) {
                this.$loading()
                const header = [
                    [
                        'OrderCode*',
                        'OrderDate*',
                        'ShipperCode*',
                        'ShipperName*',
                        'ShipperAddress*',
                        'ShipperZipcode*',
                        'ShipperTel*',
                        'DeliveryDate*',
                        'CustomerCode',
                        'Order Time',
                        'Total Boxes*',
                        'note',
                        'Weight Kgs',
                        'Total CBM',
                        'COD Amount',
                        'TrackingNumber',
                        'sender_identity_fname',
                        'sender_identity_lname',
                        'sender_identity_idcardnumber',
                        'COD_accept',
                        'CCOD_accept',
                        'insurance_accept',
                        'insurance_amount',
                        'document_return_accept',
                        'product_return_accept'
                    ]
                ]
                this.selectedRow.forEach(e => {
                    let arrData = [
                        e.orderCode,
                        this.$dayjs(e.orderDate).format('DD/MM/YYYY'),
                        e.shipperCode,
                        e.shipperName,
                        e.shipperAddress,
                        e.shipperZipcode,
                        e.shipperTel,
                        this.$dayjs(e.deliveryDate).format('DD/MM/YYYY'),
                        '',
                        e.orderTime,
                        e.totalBox,
                        e.note
                    ]
                    header.push(arrData)
                })
                this.saveExcelScgNotify(header, 'SCG-Notify-' + this.$dayjs(new Date()).format('DD-MM-YYYY'))
                this.$loading().close()
            } else {
                this.$message({
                    type: 'warning',
                    message: 'กรุณาเลือกรายการ'
                })
            }
        },
        handleSelectionChange (val) {
            this.selectedRow = val
        }
    }
}
</script>

<style lang="scss">
.ScgDatePick input {
  text-align: center;
}
.tableSCG {
  th {
    background-color: black;
    color: white;
  }
}
</style>
